import React from 'react'
import {useSelector} from 'react-redux'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {getOfferAccessFlowSettings} from 'modules/sapiSearch/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {ProviderLogo} from '@vio/shared/src/search/ProviderLogo'
import {ProviderName} from '@vio/shared/src/search/ProviderName'

type OfferLogoVariant = 'logo' | 'name' | 'iconAndName' | 'icon' | 'circle'
interface Props {
  hotelId: string
  offer: SearchOffer
  variant?: OfferLogoVariant
  height?: number
  size?: 'sm' | 'md'
  providerCodeOverride?: string
  isPrimaryOffer?: boolean
  isSecondaryInlineOffer?: boolean
  isSplitBooking?: boolean
  isAppLockedDeal?: boolean
}

const Wrapper = styled.div`
  .--is-secondary-inline-offer img {
    height: 16px;
  }
`

export const OfferLogo: React.FC<Props> = ({
  hotelId,
  offer,
  isPrimaryOffer = false,
  isSecondaryInlineOffer = false,
  variant = 'logo',
  size = 'md',
  providerCodeOverride,
  isSplitBooking = false,
  isAppLockedDeal = false
}) => {
  const {isAuthLocked} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  const {intermediaryProvider, metadata} = offer || {}

  if (isAuthLocked && !providerCodeOverride && !isSplitBooking)
    return (
      <div data-id="Logo">
        <Icon
          size={isPrimaryOffer ? 'md' : 'xs'}
          name="EngineeredPrivateDeal"
          colorPath="content.brand.primary"
        />
      </div>
    )

  return (
    <Wrapper data-id="Logo">
      <Box display="flex" gap="s200">
        {(variant === 'logo' ||
          variant === 'icon' ||
          variant === 'iconAndName') && (
          <ProviderLogo
            className={cx(
              isSecondaryInlineOffer && '--is-secondary-inline-offer'
            )}
            variant={variant === 'iconAndName' ? 'icon' : variant}
            providerCode={
              providerCodeOverride ? providerCodeOverride : intermediaryProvider
            }
            brandInfo={isAppLockedDeal ? null : metadata?.brandInfo || null}
          />
        )}
        {(variant === 'name' || variant === 'iconAndName') && (
          <ProviderName
            providerCode={
              providerCodeOverride ? providerCodeOverride : intermediaryProvider
            }
            size={size}
            brandInfo={isAppLockedDeal ? null : metadata?.brandInfo || null}
          />
        )}
      </Box>
    </Wrapper>
  )
}
